import PropTypes from 'prop-types';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, Text} from '../../ui';
import css from '../styles/FiltersModal.module.css';
import {useSearchFilters} from '../utils/useSearchFilters';

const FiltersModal = ({filters, closePopup}) => {
  // @ts-ignore
  const {handleClearAllFiltersClick} = useSearchFilters();

  return (
    <div className={css.modalWrapper}>
      <div className={css.title}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_24}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.filters'} />
        </Text>
      </div>
      <div className={css.modalContent}>{filters}</div>
      <div className={css.controls}>
        <Button height={Button.HEIGHT.SMALL} onClick={closePopup}>
          <TextLocal id={'search.searchForResult'} />
        </Button>
        <Button
          height={Button.HEIGHT.SMALL}
          color={Button.COLOR.SECONDARY}
          onClick={handleClearAllFiltersClick}
        >
          <TextLocal id={'search.clearAll'} />
        </Button>
      </div>
    </div>
  );
};

FiltersModal.propTypes = {
  filters: PropTypes.node,

  closePopup: PropTypes.func,
};

export default FiltersModal;
